<nav class="stat-pagination">
  <ul class="pagination">
    <li class="page-item">
      <a class="page-link" (click)="firstLessonClicked()" *ngIf="first_lesson">
        Первая
      </a>
    </li>
    <li>
      <a class="page-link" *ngIf="current_lesson?.lesson_number > 5">
        ...
      </a>
    </li>
    <li class="page-item" *ngFor="let lesson of previous_lessons">
      <a class="page-link" (click)="lessonClicked(lesson)">
        {{ lesson?.lesson_number }}
      </a>
    </li>
    <li class="page-item" class="active">
      <a class="page-link">
        {{ current_lesson?.lesson_number }}
      </a>
    </li>
    <li class="page-item" *ngFor="let lesson of next_lessons">
        <a class="page-link" (click)="lessonClicked(lesson)">
          {{ lesson?.lesson_number }}
        </a>
      </li>
    <li>
      <a class="page-link" *ngIf="current_lesson?.lesson_number < last_lesson?.lesson_number - 4">
        ...
      </a>
    </li>

    <li class="page-item">
      <a class="page-link" (click)="lastLessonClicked()" *ngIf="last_lesson">
        Последняя
      </a>
    </li>
  </ul>
</nav>
